import Header from './Header'
import LogoAnimation from './LogoAnimation'

import './interface-slider'
import './tab'
import './modal'
import './hover'
import './2x'
import './filter'
import './case-slider'
import './menu'
import './manual-slider'
import './interface-mobile-slider'
import './readmore'
import './clipboard'
import './loaderButton'
import './search'
import './scrollTo'
import './counter'
import './page-progress'
import './scrollUp'
import './blog'
import './image-slider'
import './card-slider'
import './case-toggle'
import './video-modal'
import './solution-logos-slider'
import './case-card-slider'
import './awards-slider'
import './reviews-slider'
import './module'
import './index'
import './toggle'
import './career-slider'
import './device-nav'
import './file-upload'
import './collapse'
import './video-playlist'
import './count'
import './tippy-init'
import './cost'
import './support'
import './top-banner'
import './cookie'

new LogoAnimation({
  container: $('.js-logoAnimation'),
  shift: $(window).width() >= 768 ? 460 : 340,
  fps: 50,
  height: $(window).width() >= 768 ? 23 : 17,
})

new Header()
